// User ID to Name mapping for Company Reports and other components
// Maps Auth0 user IDs to display names and avatars
// IDs are truncated for security - only using last 8 characters after the pipe

export const USER_ID_NAME_MAP = {
  // Truncated ID (last 8 chars) -> User info
  'c1c2e030': {
    name: 'a.falzetti+monitor_ufficio_1@onoranzefunebricloud.com',
    picture: 'https://s.gravatar.com/avatar/f11ce5a48b0c00418f6e9fbb39bf1c04?s=480&r=pg&d=https%3A%2F%2Fcdn.auth0.com%2Favatars%2Fa.png'
  },
  '34253562': {
    name: 'Emanuele Albertazzi',
    picture: 'https://lh3.googleusercontent.com/a/ACg8ocJE5pQMJvRqfxH76YlDqvoTL0t_dli8-cPPMt49o8yGj-qzxA=s96-c'
  },
  '51264893': {
    name: 'Daniela Maiero',
    picture: 'https://lh3.googleusercontent.com/a/ACg8ocKY-sNYwUdAWHWGHsxRFfjnj6Z_sd6H_Nymsr0-KQIBrm5C4A=s96-c'
  },
  '58584252': {
    name: 'Massimo Mercuri',
    picture: 'https://lh3.googleusercontent.com/a-/ALV-UjUX8uRq733uwVUJ_AThmYKgknwQ_tXKZQqHSYIPBDr_d1DKG1yfhLJC_8G2sLV7iDNmoVXwEAEo9eUugBFqIj8MXKY67IXTwmmvoASItqWulTwex12TIJbM_aQp_hlcP47NbFZ0ds62NlnsTH09e4a_q9WFK-wfD_irac1DWxG-TOgP9GQe5Inh_qJFTlXPahqT5rS_HME661dbrBi5yw0TgAFGD80w65_dIg9BeqrHJBvQJBlANaOvvc7pexwfufu9qjaqyjzVEPvPnAhz77I3DuwiUCd1g_vDa4LTB7-nUUBl5R9W7ubE9R_SGZT7DLvKA43NNgCrdjwhQpDpZvRl-0IarYAbJPmR661p4Yi4pznYEI0cGGwXou89ziBBQrl03SaT8tIlr0vgxmjH1Sjs8wcOg5NngDnXbUq61y7uqKikQpgXahz3pJk0k5HzfIQUFTyS8eWNJosBLuMvhROFQgqFmEPqbJIWr-j1dpEjg160KlUk9cRHXfHAhpgH1-i_Qj_uyGrWeZa-GgWYEkxnYE1TCx9ObEQpwMpYA_9moHP_it_XVGW3A7EjEgmXemDJ7bRP3W2SNu5oMZKI9hp4vH5ZGhkZNOTFowCvyLpY5F9VKe4fXcZZmB0Y0d1yci21bOWvD0F1xB9XxsFk9Ak9TY2pYf3vwKgVZuxi_XyImvlBiHCp5a13xOFF9vdwoBJn4FFaNsGQfneBFkA35PSci6OU265UGLIXmYsOX8rmw_mcbvIn23KYo3hXy4Ad1fkc39wMwg2EqIOjVMeu7R8tkh32HFv2X3ckSsmPvqQO3fa4rC5fx6geARtT7zKzDFW_7L46g_ILQ6oCpaN-4rLCUsW0kG7G-V1mUADqRFwCOm_GzRbbfp8aA6Y2YjNNHDf9OZZvWktl1MxY8xVenER_P8UwGa1hKFk4khhdcQtpxYj2AOavLU-62nTm55cRSYQ76oatOHdPLq7lDFxXO9xdMeUmBkoR=s96-c'
  },
  '64867069': {
    name: 'Jacopo Jacoponi',
    picture: 'https://lh3.googleusercontent.com/a-/ALV-UjX2QQKofOY5H-nyWBZ07f-ZmtX5_xPCae_Rjz3oQ19DJFDjN7Oqz7xkDyEAG4-2nQaQLuWDWxZwnnPNHMkVNXhWDwHxZ4EFIZACQlDff9OIYcSubsNmPIyli9CTxRfLqJgWcZVn0FD1fgDmXIzWft37OVP_I6qzqNTwGSLm176n47Cqgo-_SeJXlDZN0qzf1VXSOIJlAc4VWNb6voeb3NfD1ZC82-nKfHRGkHKFycvFuecaaAyH85ss2RsHQV3HyXGCOIQBcSMZ4vsstmmC_0_91n7M4zmPGhJZosW8ASAlOlUeYgeilQ2msuDLAUM8oLXG9SXsEpOdtM7SKjXD5G4NvSyZiUCmWZi81ahHJ7loQQKs4typDiEcs6jk2HhARm8FQnv9JbHCn6Gvdm8jnxOgPMdpWH-LAZCq8daazxRR9xkeP1WJCIPKwtOrkwtDO0tqLa-xbxNgc4sWAgFJZB0c74IgdTd9y9ukPzRxwIYIgY7MdPuA63KP6eFHVL9HF3TgbpI76movj4UO4Gk5PnbUj4erfC0dROY5ZUzC5yC-fyshrc_vTrwNkZvmqIS4nvavRF7jdiR5A2kP0EmMjdi8X4E_fcDVX8VsgPC5GrOo7Tez4jVpdLsXSaensrl1CeiaznslfhKEQIRYMVy7ziKPP84MKof3nMGm699PHc93r-01kvcBTjdTNkCFhSD__i0EdGJ6fnJOjnShrKNZIjWddb15x5Nul6t1FOeT5ySEFVgB17hnY50iCTupfQM1gLdSR_-zgTWxfU1cXafU4GCfVwpE9c8IskBUh4PlBJ97zxRRhBQMSCfT9gHL20VraV0t5_CzuPlWhnupw5XWdmhY0T2w3FyT-eQyX7TObSp3WutCb88iTG-A3wkRRegHnzfXT-B52mlLeoPV3f_SaCrlueo9s7DBQt3WMAlMhlFuNtPq9AfFiZJE8Q6xbwCsF0urh7FTzmJkwprl56Ukd0owXgXzYt21=s96-c'
  },
  '63179719': {
    name: 'Fabio Salvatore',
    picture: 'https://lh3.googleusercontent.com/a-/ALV-UjUdZQpzoAYT6kfxAR3pfIfzFUPtc_5H3juB0fWa9kw6tg2pj8AZlt01Q1VFxybaJpPYG1BWvkXNXOFT97lkMh0jJPn88-AGcWhLNqu1ov0AVhLjst7BAzy-gAGlR6KB9AqbiDnM6FRQJ6gBeWg3E-H_GVp-6G8QgaknFux11IvrgzEZTjIvNQRlg-fxIm3Uu0J0d4zn6O6746MRsYV5Bk8YjoInSFZ7UYyDH0rAB8QJ6Py-EnqjKYH1dGaVy_qaPW0apc1dVJhaNjdPJc_4tFXt0wbusd8Y6yUn8DJV9mj0zLrkEyHubDHiBRkK3JpG2vucwMg96YNZc3z-rQx0xu9e2uo0Pk7je6U17J3ELRWc6J-Y8jDWAaf786IUgGFUBx4YfdiDpLP3zxRScO8ON7iGe4SxX9V331OBD7TRbzUh3vKoKphyELcThY1RyHxqx1KshqAZZJk4bSHFeqBtyfF2YMknaGYEzTHrWUlA8T_ZRQbtoM6WJFtH6dw3tLYmpg3WLh3G_yNBhbhrbjxx-OWaJurbhPO9W7Sdb3ZMQ5z5mIJRxY3F2UIwhQp6qZRkRoRwJ9UU_Qnfni1-fO4Gg8tqBP587AEczc1o76jPKQGXYjO76waQ0_rtnXYci2ezmGcqkJ-Y0gP5I9HqGXHy2HBre_mrbfN43YFed2dXhTJPgC-Y5rxvY9YK-EBwS9IGEolI_yBW6-Pt0hc_NbgslatPgypH71i9DJfEMxObGVDUo-3Ut8rcGJ6lrNS2Bm8JkOsKjYnuvX4REgnl5z1FycmK2vV_WlDIegRucHGAvsBLkDG3QEK-QqkT34Z0GGjRpMXnhbuRD5V-up_kjiDqdmG9gSoxRmxk4kAZU1zsilaucDgYJgvbDUubMdw30cn4pjX1kxhNAmKhlkBDynHRPb2Y6rE3hPGEjnC0E5ljyENLgpJccu7hhnfaBTL3xntmt1jsA6QzO2VRf8DOaB1H1yc2KNqc7BI=s96-c'
  },
  '10288552': {
    name: 'Andrea Falzetti',
    picture: 'https://lh3.googleusercontent.com/a-/ALV-UjWGUn2BDtiOXvwt_oHS0jFy6voeaX48dqGYsJnrBv4-mmfTpleWpKvhowUOwLCtehXVykDGZ5zG46uISIw9-NojVx-D1fqPmq8jfhV9F6M21kdSVv1A2mimFVzouLMYHuMJca9ZbslsjVxMmiKulqmLkGJPSx2m-lIlg8GJx31mH3WAaeD-xjetUPFPIfsNmOsKXKn2R5uDnuynSccGFwty3kM2G9mPSNHhaOXvwypdb-8CB2QP61mgegUZEXHgc008k-uX11UH0jjGT3b-O2pKg_m-xm9Zs0QDaKv3tpWdqp-I5Hr2MSvx5LpIwThy0RWhbmvPkPU7fmWEBYuj-p_qYmCMzlWE_SFAVyevMHy9IgmeOfzUqA3WrX2HvOcu1jLcWNIxF20c3rvpnBM-VjvMMSEytHjQYVe8nYS8ug-dXjsqNTTanxGvYt2qtcc8U8ssfj2J23WMH7ETJnkyC-A_DJDVFsQ6DJi4KrYWf7QFxblqoYfMBuWXnhwRiVsSA7f1YgMBpZlVYFPKgxAbCKBo5wzzfX7y1XN-850buTc7-Rv9HsjQg0bS_bbGHTQuykyh4X_wreFd4j_Hzyy5HAdy5p_KPCx3TzJgER2Xdxzw9QoGBp1JAUZa1r7dtRze-d7lwrqhh4EjrOYQU9M4JBGROWgZ91xxTMN1Kp4cNTm3V5W01mUUqKFLo3oxVKt2K2A0MglVNhDajzzCWZcBuVdSj9Vy6eC-hNTreXYhXRIxCSJFfnJAe22GrM2hDYUlE3-cXpR1SBWIJA8h3qJRpSoAeHqVa8GhBiR0uDKJ0zH8Ij5oRBAPqB6JcfukXCRneNCqx7WdFmMQ-Q9iPuvhQuhfG-q9QA5DwUDFk0A744CglPxv4qCsl1EETJSjDL8HzkQ3c5PWRiMI5q-pyjh25QzmHmYDzpmLVT51lpdhiXiyN-zQjIauXpMV-qJG8aU3q080PxsZlEqTnZmAJ6GiMdlXgi1z6QJa=s96-c'
  },
  '53335430': {
    name: 'Riccardo Di Noia',
    picture: 'https://lh3.googleusercontent.com/a/ACg8ocIY7n2L1FCH77p77Fluqcwh4Y_q-gw8Q3fxm3rQmneC5oGvXg=s96-c'
  },
  '18786815': {
    name: 'Leonardo Cerasoni',
    picture: 'https://lh3.googleusercontent.com/a-/ALV-UjWtYob0ciIegOpJorX1KVUVTUvQTOup-UCbR0l4En4dMGZWKAmoQIqlj4lpiWWfOmEImf75tdLig9Xf78MChbfOYLM6rCmHcuL0lw6TzGr9wmmdO1CLp0-tx6Gpu3ZKkaAHd3zUjeags4colPGZwVabby5ttJbfp-HMAJstE76DjgtPAZULySEDdjzSEwSv5n3Tttd6hVMM1XB9EgPNv22t62Y6dyJuxpkBNGcklujTmwX6spYkSKxraUUKl6hPUTW5MialruAa8DZXZruheBdorxRok7zFKu8xYMhlaSQOfv9uMjzJkTCwaunLbCxwnj_uB-_a33T-kzJpEBviQWQOaOCexcUPGAkYgDSx9q-SzNUzMriNrsrqcxpfTCOb9_fJWZh5IR87IiNmLOkJmtXt_QlHMR7Cvz79J9-oXD0tksEU5BXIJbcrj9Hwq8TfJ06sSkj-Ol7mzyQCjI1X_U05WH5WTimYYSYodd7YGmFSF-9ZhXxroHUSMWTr0fRu70FbwR2-o5vMJZmG8LtVOJA_Eom_lgkQBlGOnT9rTlfB5UqlIyAhr3NQodhbSFu0pncDfxF__9ddKAKNwtHbem7M-3NQsPfMIH_lgWRDZ673PPsflsL4Ke0bEuO-LJnLtDXIjoBfBEb1FrU4b1D0-wdn0n57c0QSd5886yurJBSgnuhFxnxofQK1R4vzipj2xHlTh4czgDMfWDisD2A9PuajaT-aW60PPl2DbcuhGaUtnVdMSxz4t6SSMpM5mdOk0Q2hIaY60YHrimjcHxIgoN6Q6Wi_s9uxlS3q8N4Y6tyMsyMdSBmuPId_YgWKx9CvdlpNEfGi8qVpXmUJGNYZewn2rB-Vxdb-N31TWOJoEwtpPZ1PkKxs1mAn1ZlWgHtOii-x_1XKknxrFEhAgIzxNIFUGQoAEBVG0_aFFeZarY9Sz9l54jfWuKMnxT7mU1CCbaRUMgaxCl4Grrj8-3QijjjIlwt_-G1Hqw=s96-c'
  },
  '12126174': {
    name: 'Roberta Casco',
    picture: 'https://lh3.googleusercontent.com/a/ACg8ocKFQqv9KnsWr8YQ9BX_rQ9u2GeDBedts_ywbv4om4uRkaLqaA=s96-c'
  }
};

// Helper function to extract truncated ID from full user ID
export const getTruncatedId = (fullUserId) => {
  if (!fullUserId) return null;
  
  // Handle different ID formats
  if (fullUserId.includes('|')) {
    const parts = fullUserId.split('|');
    const idPart = parts[1];
    // Return last 8 characters
    return idPart.slice(-8);
  }
  
  // If no pipe, return last 8 characters
  return fullUserId.slice(-8);
};

// Helper function to get user info from ID
export const getUserInfoFromId = (userId) => {
  const truncatedId = getTruncatedId(userId);
  return USER_ID_NAME_MAP[truncatedId] || null;
};

// Helper function to get user name from ID
export const getUserNameFromId = (userId) => {
  const userInfo = getUserInfoFromId(userId);
  return userInfo?.name || userId;
};

// Helper function to get user picture from ID
export const getUserPictureFromId = (userId) => {
  const userInfo = getUserInfoFromId(userId);
  return userInfo?.picture || null;
};

// Helper function to get initials from name or ID
export const getUserInitials = (userId) => {
  const name = getUserNameFromId(userId);
  
  // If it's still an ID (not mapped), try to extract something meaningful
  if (name.includes('|')) {
    // For unmapped IDs, use the first character after the pipe
    const parts = name.split('|');
    return parts[1] ? parts[1].charAt(0).toUpperCase() : '?';
  }
  
  // Check if it's an email
  if (name.includes('@')) {
    // For emails, use first character
    return name.charAt(0).toUpperCase();
  }
  
  // For mapped names, get initials
  const words = name.split(' ');
  if (words.length >= 2) {
    return `${words[0].charAt(0)}${words[words.length - 1].charAt(0)}`.toUpperCase();
  }
  return name.charAt(0).toUpperCase();
};

export default USER_ID_NAME_MAP;